import { IRegistrationRequestFormData } from "../components/RegistrationRequestForm";
import { ILeadReceipt } from "../service/dtos";

export function convertLeadReceiptToFormData(
    contact: ILeadReceipt | undefined,
    supplierId: string,
    secureId: string,
    companyName: string,
    requestNumber: string
): IRegistrationRequestFormData | undefined {
    if (contact === undefined) return undefined;
    return {
        contactName:
            contact.firstName || contact.surName
                ? (contact.firstName ?? "") + " " + (contact.surName ?? "")
                : "",
        emailAddress: contact.email ?? "",
        mobileNumber: contact.mobileNumber.number ?? "",
        companyName: companyName,
        secureId: secureId,
        supplierId: supplierId,
        requestNumber: requestNumber
    };
}
